import React from "react";
import { Card, Alert, Spin, Descriptions, Tag, Typography, Space, Divider, Button, message } from "antd";
import { FileProtectOutlined, UserOutlined, CarOutlined, WarningOutlined, CopyOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { setVistaGSeguros } from "../../../../context/actions/polizarioActions";
import { AlertaVip } from "../../../crearServicio/captura/fase1/polizarioGS/_AlertaVip";

const { Text } = Typography;

export const PolizarioGS = () => {
  const dispatch = useDispatch();

  const { vistaGSeguros, loadingGSeguros, gsegurosEmision, gsegurosResponse } = useSelector(
    (state) => state.polizarioReducer
  );
  const { validador1 } = useSelector((state) => state.asistenciasReducer.captura);

  const siniestros = gsegurosResponse?.siniestro ?? [];

  const copiarTodo = () => {
    const data = gsegurosEmision;
    const texto = `Póliza: ${data.validador1}
Vigencia: ${data.validador2}
Estatus: ${data.estatus}
Cliente VIP: ${data.cliente_vip}
Condiciones Especiales: ${data.condiciones_especiales}

--- Asegurado ---
Nombre: ${data.nombre_asegurado} ${data.apellido_paterno} ${data.apellido_materno}
Teléfonos: ${data.telefonos}
Tipo: ${data.tipo_persona}
Email: ${data.email}
Domicilio: ${data.domicilio}

--- Vehículo ---
Vehículo: ${data.vehiculo}
Modelo: ${data.modelo}
Color: ${data.color}
Placas: ${data.placas}
No. Serie: ${data.numero_serie}`;

    navigator.clipboard.writeText(texto).then(() => {
      message.success("Datos copiados al portapapeles");
    });
  };

  return (
    <>
    <AlertaVip VistaGSeguros={vistaGSeguros} />
    <Card size="small">
      <div className="crear-servicios-v2__section-header">
        <div className="crear-servicios-v2__section-header-title">
          <FileProtectOutlined />
          <span>Polizario General de Seguros</span>
        </div>
      </div>

      {!validador1 && (
        <Alert message="Ingrese un validador y presione Buscar" type="info" />
      )}

      {validador1 && loadingGSeguros && (
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      )}

      {validador1 && !loadingGSeguros && vistaGSeguros === 0 && (
        <Alert message="Presione Buscar para consultar" type="info" showIcon />
      )}

      {validador1 && !loadingGSeguros && gsegurosEmision?.estatus === "No existe poliza" && (
        <Alert message="No existe póliza" type="warning" showIcon />
      )}

      {/* EMISIÓN */}
      {validador1 && !loadingGSeguros && vistaGSeguros === 1 && gsegurosEmision?.estatus !== "No existe poliza" && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space wrap>
            <Text strong style={{ fontSize: 15 }}>{gsegurosEmision.validador1}</Text>
            {gsegurosEmision.validador2 && <Tag>{gsegurosEmision.validador2}</Tag>}
            <Tag color={gsegurosEmision.estatus === "Vigente" ? "success" : "default"}>
              {gsegurosEmision.estatus}
            </Tag>
            {gsegurosEmision.cliente_vip && <Tag color="gold">Cliente VIP: {gsegurosEmision.cliente_vip}</Tag>}
            {gsegurosEmision.condiciones_especiales && <Tag color="blue">Condiciones especiales: {gsegurosEmision.condiciones_especiales}</Tag>}
            <Button 
              icon={<CopyOutlined />} 
              size="small" 
              onClick={copiarTodo}
            >
              Copiar todo
            </Button>
          </Space>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><UserOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Asegurado</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Validador 2">{gsegurosEmision.validador2}</Descriptions.Item>
            <Descriptions.Item label="Cliente VIP">{gsegurosEmision.cliente_vip}</Descriptions.Item>
            <Descriptions.Item label="Condiciones Especiales" span={2}>{gsegurosEmision.condiciones_especiales}</Descriptions.Item>
            <Descriptions.Item label="Nombre" span={2}>
              {`${gsegurosEmision.nombre_asegurado} ${gsegurosEmision.apellido_paterno} ${gsegurosEmision.apellido_materno}`}
            </Descriptions.Item>
            <Descriptions.Item label="Teléfonos">{gsegurosEmision.telefonos}</Descriptions.Item>
            <Descriptions.Item label="Tipo">{gsegurosEmision.tipo_persona}</Descriptions.Item>
            <Descriptions.Item label="Email" span={2}>{gsegurosEmision.email}</Descriptions.Item>
            <Descriptions.Item label="Domicilio" span={2}>{gsegurosEmision.domicilio}</Descriptions.Item>
          </Descriptions>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><CarOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Vehículo</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Vehículo" span={2}>{gsegurosEmision.vehiculo}</Descriptions.Item>
            <Descriptions.Item label="Modelo">{gsegurosEmision.modelo}</Descriptions.Item>
            <Descriptions.Item label="Color">{gsegurosEmision.color}</Descriptions.Item>
            <Descriptions.Item label="Placas">{gsegurosEmision.placas}</Descriptions.Item>
            <Descriptions.Item label="No. Serie">{gsegurosEmision.numero_serie}</Descriptions.Item>
          </Descriptions>

          <Text
            type="secondary"
            style={{ cursor: "pointer", fontSize: 12 }}
            onClick={() => dispatch(setVistaGSeguros(2))}
          >
            Ver siniestros ({siniestros.length}) →
          </Text>
        </Space>
      )}

      {/* SINIESTROS */}
      {validador1 && !loadingGSeguros && vistaGSeguros === 2 && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Text
            type="secondary"
            style={{ cursor: "pointer", fontSize: 12 }}
            onClick={() => dispatch(setVistaGSeguros(1))}
          >
            ← Volver a emisión
          </Text>

          {siniestros.length === 0 && (
            <Alert message="Sin siniestros registrados" type="info" showIcon />
          )}

          {siniestros.map((s, i) => (
            <Card key={i} size="small">
              <Space direction="vertical" size={4} style={{ width: "100%" }}>
                <Space>
                  <WarningOutlined />
                  <Text strong>{s.numero_siniestro}</Text>
                  <Tag>{s.estatus}</Tag>
                </Space>
                <Divider style={{ margin: "6px 0" }} />
                <Descriptions column={2} size="small">
                  <Descriptions.Item label="Validador 2">{s.validador2}</Descriptions.Item>
                  <Descriptions.Item label="Cliente VIP">{s.cliente_vip}</Descriptions.Item>
                  <Descriptions.Item label="Condiciones Especiales" span={2}>{s.condiciones_especiales}</Descriptions.Item>
                  <Descriptions.Item label="Tipo">{s.tipo_siniestro}</Descriptions.Item>
                  <Descriptions.Item label="Ajustador">{s.ajustador}</Descriptions.Item>
                  <Descriptions.Item label="Vehículo">{s.vehiculo}</Descriptions.Item>
                  <Descriptions.Item label="Modelo">{s.modelo}</Descriptions.Item>
                </Descriptions>
              </Space>
            </Card>
          ))}
        </Space>
      )}
    </Card>
    </>
  );
};
